// Copyright (C) 2021 Bystronic Laser AG

import axios from 'axios';
import { BaseUrl } from '@/models/constants';
import {
  AlertKPI,
  AlertKPIGroup,
  WccAlertMetric,
} from '@/models/enums/AlertsEnums';
import { usePersistentStore } from '@/store/persistent';
import { WccAlert } from '@/models/wccAlert';

class WorkCenterAlertsService {
  store = new (class {
    kpiGroups() {
      return usePersistentStore().wccKpiGroups;
    }

    getKpiByMetric(metric: WccAlertMetric): AlertKPI<WccAlertMetric> {
      return usePersistentStore().getWccAlertKpiByMetric(metric)!;
    }

    updateKpiGroups(kpiGroups: AlertKPIGroup<WccAlertMetric>[]) {
      usePersistentStore().setWccKpiGroups(kpiGroups);
    }
  })();

  getAllByCustomerId(tenantId: number): Promise<WccAlert[]> {
    return axios
      .get<WccAlert[]>(`${BaseUrl}/work-center-alerts?tenantId=${tenantId}`)
      .then((response: any) => {
        return response.data;
      });
  }

  async delete(id: number) {
    await axios.delete(`${BaseUrl}/work-center-alerts/${id}`);
  }

  async update(alert: WccAlert) {
    await axios.put(`${BaseUrl}/work-center-alerts/`, alert);
  }

  async create(alert: WccAlert) {
    await axios.post(`${BaseUrl}/work-center-alerts/`, alert).then((response: any) => {
      return response.data;
    });
  }

  getAllEmailRecipientsByAlertId(alertId: number): Promise<string[]> {
    return axios
      .get<string[]>(`${BaseUrl}/work-center-alerts/emailrecipients/${alertId}`)
      .then((response) => {
        return response.data;
      });
  }

  async getAllKpis(): Promise<AlertKPIGroup<WccAlertMetric>[]> {
    const alertKpis = await axios
      .get<AlertKPIGroup<WccAlertMetric>[]>(`${BaseUrl}/work-center-alerts/kpis`)
      .then((response) => response.data);
    this.store.updateKpiGroups(alertKpis);
    return alertKpis;
  }
}

export const workCenterAlertsService = new WorkCenterAlertsService();
